import {catchError, finalize, Observable, shareReplay, switchMap, throwError} from 'rxjs';
import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {Tokens} from '../../entities/authentication/tokens.entity';

let refreshRequest$: Observable<Tokens> | null = null;

export function authenticationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authenticationService = inject(AuthenticationService);
  const isAuthEndpoint = req.url.includes('/api/v1/auth/login')
    || req.url.includes('/api/v1/auth/refresh')
    || req.url.includes('/api/v1/auth/logout');

  if (isAuthEndpoint) {
    return next(req);
  }

  const tokens = authenticationService.getTokens();

  if (tokens) {
    const clonedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${tokens.token}`)
    });

    return next(clonedReq).pipe(
      catchError(err => {

        if (err.status === 401) {
          if (!refreshRequest$) {
            refreshRequest$ = authenticationService.refreshToken().pipe(
              finalize(() => {
                refreshRequest$ = null;
              }),
              shareReplay(1)
            );
          }

          return refreshRequest$.pipe(
            switchMap((newTokens) => {
              const newReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newTokens.token}`)
              });

              return next(newReq);
            }),
            catchError(refreshError => {
              authenticationService.logout();
              return throwError(() => refreshError);
            })
          );
        }

        return throwError(() => err);
      })
    );
  }

  return next(req);
}
